exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Toolbar___3u3I_ {\n  padding: 0.25rem 0;\n  margin-bottom: 0.25rem;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.Content___3i3NJ {\n  user-select: none;\n  overflow-y: auto;\n}\n\n.Component___Y5kFG {\n  flex: 1;\n  font-weight: bold;\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n.CurrentCommit___21fVV {\n  margin: 0.25rem 0;\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n}\n", ""]);

// exports
exports.locals = {
	"Toolbar": "Toolbar___3u3I_",
	"Content": "Content___3i3NJ",
	"Component": "Component___Y5kFG",
	"CurrentCommit": "CurrentCommit___21fVV"
};